import * as React from 'react'
import { styled } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'
import { Icons } from '../assets/icons'
import { apiService } from '../services/apiServices'
import { useCommonCtx } from '../context/useCommonCtx'
import { isMobilePortrait } from '../utils'
import { downloadSession, saveLocalSession } from '../context/session/helpers'
import { FSM_ACTIONS_TYPE } from '../context/types'
// const viewportWidth = window.innerWidth;

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center', //'flex-start',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    // Override media queries injected by theme.mixins.toolbar
    '@media all': {
        minHeight: isMobilePortrait() ? 75 * 0.85 : 45 * 0.85,
    },
}))
interface Props
    extends Pick<FSM_ACTIONS_TYPE, 'topCenter' | 'topLeft' | 'topRight'> {
    title: string
    subtitle?: string
    topTooltip?: string
}

export default function TopBar(p: Props) {
    const { topLeft, topRight, topCenter, title, subtitle } = p
    const commons = useCommonCtx()
    const assessmentParams = commons?.state?.params?.assessmentParams
    const brandParams = commons?.state?.params?.brandParams
    const hasDownloadDebug =
        commons.userEmail.includes('fitme') ||
        (assessmentParams['debug_mode'] === 1 && !assessmentParams?.is360)
    return (
        <Box sx={{ zIndex: 999 }} title={p.topTooltip}>
            <AppBar color="primary" position="static">
                <StyledToolbar
                    variant="dense"
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        // borderColor: 'red',
                        // borderWidth: '1px',
                        // borderStyle: 'solid',
                    }}
                >
                    {/* LEFT */}
                    <div
                        style={{
                            flex: 1,
                            textAlign: 'left',
                            // borderColor: 'red',
                            // borderWidth: '1px',
                            // borderStyle: 'solid',
                        }}
                    >
                        {topLeft && (
                            <Button
                                size={'small'}
                                variant={topLeft.variant ?? 'outlined'}
                                disabled={!topLeft.onClick || topLeft.disabled}
                                onClick={topLeft.onClick}
                                color={topLeft.color ?? 'secondary'}
                                startIcon={
                                    topLeft.Icon &&
                                    topLeft.label && <topLeft.Icon />
                                }
                                sx={{
                                    minWidth: '1rem',
                                }}
                            >
                                {topLeft.Icon && !topLeft.label ? (
                                    <topLeft.Icon />
                                ) : (
                                    topLeft.label
                                )}
                            </Button>
                        )}
                    </div>
                    {/* CENTER */}
                    <div
                        style={{
                            flex: 5,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        {topCenter && (
                            <Button
                                size={'small'}
                                variant={topCenter.variant ?? 'outlined'}
                                disabled={
                                    !topCenter.onClick || topCenter.disabled
                                }
                                onClick={topCenter.onClick}
                                color={topCenter.color ?? 'secondary'}
                                startIcon={topCenter.Icon && <topCenter.Icon />}
                            >
                                {topCenter.label}
                            </Button>
                        )}
                        {title && (
                            <Typography
                                variant={isMobilePortrait() ? 'h6' : 'h5'}
                                className="text-center"
                            >
                                {title}
                            </Typography>
                        )}
                        {subtitle && (
                            <Typography
                                variant={isMobilePortrait() ? 'body2' : 'body1'}
                                className="text-center"
                            >
                                {subtitle}
                            </Typography>
                        )}
                    </div>

                    {/* RIGHT */}
                    <div
                        style={{
                            flex: 1,
                            textAlign: 'right',
                            // borderColor: 'red',
                            // borderWidth: '1px',
                            // borderStyle: 'solid',
                        }}
                    >
                        {hasDownloadDebug && (
                            <Button
                                onClick={() =>
                                    downloadSession(commons.sessionData)
                                }
                                size="small"
                                color="inherit"
                                sx={{
                                    minWidth: '1rem',
                                }}
                            >
                                <Icons.Download />
                            </Button>
                        )}
                        {!hasDownloadDebug && (
                            <Button
                                onClick={() => {
                                     // FIXME deprecated saveLocalSession - no horodatage ! 
                                // -> setAndSaveSessionData
                                    saveLocalSession(commons.sessionData)
                                    apiService.logout(
                                        brandParams?.returnUrl
                                    )
                                    commons.resetFn()
                                }}
                                size="small"
                                color="inherit"
                            >
                                <Icons.LogoutIcon />
                            </Button>
                        )}
                    </div>
                </StyledToolbar>
            </AppBar>
        </Box>
    )
}
